export default `
query categoryList($uids: [String!]) {
  categoryList(filters: {category_uid: {in: $uids}}) {
    uid
    name
    url_path
  }
}
`;
